/**
 * Similar to an array.map function except only keeps elements with a unique key
 *
 * @param array - array to map over
 * @param uniqueKey - the key each element has, onle one element with the same key will be kept in the result
 * @param mapFn - a function to map each element to in the resulting array
 * @returns A array where each element is the result of calling mapFn, with elements with duplicate keys removed
 */
export const uniqueMap = <T, R>(
  array: Array<T>,
  uniqueKey: ((element: T) => string | number | null | undefined),
  mapFn: (element: T) => R,
) => {
  const object = array.reduce((acc: Record<string | number, R>, current) => {
    const key = uniqueKey(current);
    if (key) {
      acc[key] = mapFn(current);
    }

    return acc;
  }, {});

  return Object.values(object);
};
